const initColorPicker = () => {
  const holders = [...document.querySelectorAll('.js-interactive-color')];

  if (holders) {
    holders.forEach((holder) => {
      const radios = [...holder.querySelectorAll('input')];
      const text = holder.querySelector('.current-color');

      function setCurrentColor(color) {
        text.textContent = color;
      }

      radios.forEach((radio) => {
        if (radio.checked) {
          setCurrentColor(radio.getAttribute('data-color'));
        }

        radio.addEventListener('click', () => {
          const currentColor = radio.getAttribute('data-color');

          setCurrentColor(currentColor);
        });
      });
    });
  }
};

export default initColorPicker;
